import * as React from 'react';
import { Icon, PopupAction } from '@teamsnap/teamsnap-ui';
import { AuthContext } from 'auth/dist/contexts';
import { hasPermissionForOrg, Permission } from 'core/permissions';
import { Member } from 'models';
import { useHistory } from 'react-router-dom';

const PopupItem = ({ text, icon }: { text: string; icon: string }) => (
  <div>
    <Icon name={icon} style={{ marginRight: '6px' }} />
    {text}
  </div>
);

const getActionsColumn = (
  orgId: number,
  programId: number,
  seasonId: number,
  member: Member,
  setActionMembers: ([Member]) => void,
  setShowDeleteModal: (boolean) => void,
  setShowCopyModal: (boolean) => void,
  setShowTransferModal: (boolean) => void,
  setShowEditModal: (boolean) => void
) => {
  const ActionsColumn = () => {
    const context = React.useContext(AuthContext);
    const canUserUpdateSeason = hasPermissionForOrg(context.user, Permission.SeasonUpdate, orgId);

    const history = useHistory();

    const updateSeasonActions = canUserUpdateSeason
      ? [
          {
            text: <PopupItem text="Edit" icon="edit" />,
            callback: () => {
              setActionMembers([member]);
              setShowEditModal(true);
            },
          },
          {
            text: <PopupItem text="Delete" icon="trash" />,
            callback: () => {
              setActionMembers([member]);
              setShowDeleteModal(true);
            },
          },
          {
            text: <PopupItem text="Copy profile" icon="add-member" />,
            callback: () => {
              setActionMembers([member]);
              setShowCopyModal(true);
            },
          },
          {
            text: <PopupItem text="Transfer" icon="rostering" />,
            callback: () => {
              setActionMembers([member]);
              setShowTransferModal(true);
            },
          },
        ]
      : [];

    const actions = [
      {
        text: <PopupItem text="View" icon="search" />,
        callback: () =>
          history.push(`/organizations/${orgId}/programs/${programId}/seasons/${seasonId}/participants/${member.id}`),
      },
      ...updateSeasonActions,
    ];

    if (actions.length > 0) {
      return (
        <>
          <PopupAction direction={['down']} text="..." actions={actions} popupStyle={{ width: '180px' }} />
        </>
      );
    }
    return <></>;
  };

  return <ActionsColumn />;
};

export default getActionsColumn;
